export * from '../federacao/list/federacaoList.component';
export * from '../federacao/create/federacaoCreate.component';
export * from '../federacao/edit/federacaoEdit.component';
export * from '../federacao/detail/federacaoDetail.component';
export * from '../federacao/search/federacaoSearch.component';